import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import Button from '../../../components/Button';
import Divider from '../../../components/Divider';
import ServiceType from '../../../types/ServiceType';
import ServiceDeleteConfirmation from './serviceDeleteConfirmation';
import ServiceSaveForm from './serviceSaveForm';
import ServiceTable from './serviceTable';
import styles from './style.module.scss';

function Services() {
    const [modalSaveOpened, setModalSaveOpened] = useState(false);
    const [modalRemoveOpened, setModalRemoveOpened] = useState(false);

    const [service, setService] = useState<ServiceType | null>(null);
    const handleServiceClick = () => {
        setService(null);
        setModalSaveOpened(true);
    };

    return (
        <div className={styles.container}>
            <h1>
                <span className={styles.headerIcon}>
                    <FontAwesomeIcon icon={faCoins} />
                </span>
                Services
            </h1>
            <Divider marginBottom="20px" />
            <div className={styles.service}>
                <div>
                    <Button
                        onClick={() => {
                            handleServiceClick();
                        }}
                        name="add"
                    >
                        Ajouter un service
                    </Button>
                </div>
                <ServiceSaveForm
                    service={service}
                    modalOpened={modalSaveOpened}
                    setModalOpened={setModalSaveOpened}
                />
                <ServiceDeleteConfirmation
                    serviceId={service?.id}
                    serviceName={service?.name}
                    modalOpened={modalRemoveOpened}
                    setModalOpened={setModalRemoveOpened}
                />
                <ServiceTable
                    setService={setService}
                    setModalSaveOpened={setModalSaveOpened}
                    setModalRemoveOpened={setModalRemoveOpened}
                />
            </div>
        </div>
    );
}

export default Services;
